import { render, staticRenderFns } from "./BusinessPanel.vue?vue&type=template&id=0fa43506&scoped=true&"
import script from "./BusinessPanel.vue?vue&type=script&lang=ts&"
export * from "./BusinessPanel.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessPanel.vue?vue&type=style&index=0&id=0fa43506&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa43506",
  null
  
)

export default component.exports